import {Component, Input, OnInit} from '@angular/core';
import {CensusBeneficiary, CensusData} from '../../../../shared/types/nso-data-portal/census-data';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {BeneficiaryRestService} from '../../../../shared/services/nso-data-portal/rest-services/beneficiary-rest.service';

@Component({
  selector: 'wsd-beneficiaries',
  templateUrl: './beneficiaries.component.html',
  styleUrls: ['./beneficiaries.component.css']
})
export class BeneficiariesComponent implements OnInit {

  @Input()
  census: CensusData;

  @Input()
  readOnly: boolean;

  beneficiaryTypes$: Observable<string[]>;

  constructor(private beneficiaryService: BeneficiaryRestService) { }

  ngOnInit() {
    this.beneficiaryTypes$ = this.beneficiaryService.getBeneficiaryTypes()
      .pipe(tap(types => types.push('OTHERS')));
  }

  get beneficiariesTotal() {
    return this.census && this.census.beneficiaries
      .reduce((total: number, beneficiary: CensusBeneficiary) => {
        return total + beneficiary.total;
      }, 0) || 0;
  }
}
